import '@styles/app.css';
import header from '@commons/header';
import main from '@commons/main';
import SearchIndex from '@vue-instances/SearchIndex';

export default function init() {
  // Commons
  header();
  main();

  // Vue instances
  SearchIndex();
}

init();
